<sm-svg-loader *ngIf="loader"></sm-svg-loader>

<!-- placeholder -->
<div class="dashboard_new" *ngIf="!loader && unpaidInvoicesData.length == 0">
  <mat-card>
    <div class="upload_sectio">
      <div class="icm_img">
        <img src="./assets/images/invoice-1.png" />
      </div>
      <mat-card-title>Track un-paid bills / invoices</mat-card-title>
      <mat-card-content
        >Keeping track of unpaid bills and invoices is a strategic function that directly impacts a business's financial health and operational efficiency. Get them all in one place.
      </mat-card-content>
      <!-- <div class="watch_vc_btn">
             <button mat-stroked-button color="primary" (click)="openvideo()">
                <mat-icon>smart_display</mat-icon>
                Watch video
             </button>
          </div> -->
    </div>
  </mat-card>
</div>

<!-- with data -->
<div class="today_booking_card" *ngIf="!loader && unpaidInvoicesData.length > 0">
  <mat-card>
    <div class="vier_tht">
      <div class="heading_ot">
        <h3>Unpaid Bills/Invoices</h3>
      </div>
      <div class="view_all_btn" *ngIf="unpaidInvoicesData[0].total_count > 4">
        <a (click)="openAllUnpaidInvoices()">{{
          unpaidInvoicesData[0].total_count > 4
            ? "View all " + unpaidInvoicesData[0].total_count
            : "View details"
        }}</a>
      </div>
    </div>
    <!--  -->
    <div class="list_yy" *ngFor="let item of unpaidInvoicesData" (click)="openInvoice(item)">
      <!-- <div class="bookign_img">
        <img
          [src]="item.customer_thumb_image"
          onerror="this.src='../../../../../../assets/images/user-avatar.svg'"
          alt=""
        />
      </div> -->
      <div class="booking_heading">
          <h3>
              {{ item.invoiceNumber ? item.invoiceNumber : "---" }}
            </h3>
            <p>{{item.creation_time | date}}
        </p>
    </div>
    <div class="booking_heading">
      <h3>
        {{ item?.customer_name ? item.customer_name : "---" }}
      </h3>
      <p>
        {{
          item?.customer_country_code
            
        }} {{item?.customer_phone}}
      </p>
    </div>
      <div class="booking_heading">
        <h3>
          {{ item?.entity_name ? item?.entity_name : "No business info" }}
        </h3>
        <!-- <p *ngIf="item.booking_type == 0 && item.data_type == 1">
          {{
            item.booking_address && item.booking_address != '' && item.booking_address != 'null' 
              ? "Visit: " + item.booking_address.address_line
              : "No address info"
          }}
        </p> -->
        <p >
          {{
            item?.entity_address
              ? item?.entity_address
              : "No address info"
          }}
        </p>
    
      </div>
      <div class="status_heading">
         <div class="booking_done">
           <h3>
               {{ item?.currency_symbol }}{{ item?.amount.toFixed(2) }}
            </h3>
            <p>Due: {{ item?.currency_symbol }}{{ item.payment_due.toFixed(2) }}</p>
           </div>
          <div class="booking_block">
          <mat-icon>arrow_forward</mat-icon>
        </div>
        </div>
    </div>

    <div
      class="list_yy"
      style="height: 61px"
      *ngFor="let item of repeatArray"
    ></div>
    <!-- <div class="list_yy">
        <div class="bookign_img">
        <img src="https://img.freepik.com/free-photo/stylish-handsome-indian-man-tshirt-pastel-wall_496169-1571.jpg" alt=""/>
        </div>
        <div class="booking_heading">
            <h3>Suraj Das</h3>
            <p>+91 74364694574</p>
        </div>
        <div class="booking_heading">
            <h3>Abc Beauty</h3>
            <p>Durgapur, WB</p>
        </div>
        <div class="booking_heading">
            <h3>3:00 PM - 4:00PM</h3>
            <p>Shop booking</p>
        </div>
        <div class="status_heading">
         <p class="colorstatus">Completed</p>
        </div>
      </div>
      <div class="list_yy" >
        <div class="bookign_img">
        <img src="https://images.pexels.com/photos/938639/pexels-photo-938639.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500" alt=""/>
        </div>
        <div class="booking_heading">
            <h3>Rahul Rathod</h3>
            <p>+91 74364694574</p>
        </div>
        <div class="booking_heading">
            <h3>Abc Beauty</h3>
            <p>Asansol, WB</p>
        </div>
        <div class="booking_heading">
            <h3>3:00 PM - 4:00PM</h3>
            <p>Shop booking</p>
        </div>
        <div class="status_heading">
         <p>In-progress</p>
        </div>
      </div>
      
      <div class="list_yy">
        <div class="bookign_img">
        <img src="https://img.freepik.com/free-photo/stylish-handsome-indian-man-tshirt-pastel-wall_496169-1571.jpg" alt=""/>
        </div>
        <div class="booking_heading">
            <h3>Rahul Rathod</h3>
            <p>+91 74364694574</p>
        </div>
        <div class="booking_heading">
            <h3>Abc Beauty</h3>
            <p>Durgapur, WB</p>
        </div>
        <div class="booking_heading">
            <h3>3:00 PM - 4:00PM</h3>
            <p>Shop booking</p>
        </div>
        <div class="status_heading">
         <p class="colorstatus">Completed</p>
        </div>
      </div> -->
  </mat-card>
</div>
